import {useEffect} from "react"
import {loadZendeskSnippet, ZENDESK_SCRIPT_ID, configureMessengerWidget} from "./zendeskWidget"
import {useUserClaimsData} from "../services/auth"

const UNIT_ZENDESK_URL = "https://static.zdassets.com/ekr/snippet.js?key=8de81817-a025-4757-832b-d69a46dcb582"

const useUnitZendesk = (shouldInitialize = false) => {
	const userTokenData = useUserClaimsData()

	useEffect(() => {
		if (!shouldInitialize) {
			return
		}

		return loadZendeskSnippet({
			id: ZENDESK_SCRIPT_ID,
			src: UNIT_ZENDESK_URL,
			onReady: () => {
				configureMessengerWidget(userTokenData)
			},
		})
	}, [shouldInitialize, userTokenData])
}

export default useUnitZendesk
